/* Service worker registration for the Presence PWA (CRA-friendly). */
const SW_URL = "/service-worker.js";

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(SW_URL)
      .then((reg) => {
        // Ask for background sync / periodic sync where supported — best effort.
        if ("sync" in reg) {
          reg.sync.register("presence-attendance-sync").catch(() => {});
        }
        if ("periodicSync" in reg) {
          reg.periodicSync
            .register("presence-periodic-flush", { minInterval: 60 * 60 * 1000 })
            .catch(() => {});
        }
        // eslint-disable-next-line no-console
        console.log("[Presence] SW registered:", reg.scope);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[Presence] SW registration failed:", err);
      });
  });
}

export function requestSyncNow() {
  if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({ type: "SYNC_NOW" });
  }
}
